import { UserCoverageSummary } from '@ampsec/platform-client';
import { CustomTooltip } from 'Components/atoms';

interface DepartmentCellRendererProps {
  data: UserCoverageSummary;
}

const DepartmentCellRenderer = ({ data: row }: DepartmentCellRendererProps) => (
  <div className="text-uppercase w-100">
    <CustomTooltip label={row.department ?? ''}>{row.department ?? ''}</CustomTooltip>
  </div>
);

export default DepartmentCellRenderer;
